export enum InternalRoutesEnum {
  CHECKOUT = "/checkout",
  NOT_FOUND = "/404",
  HOME = "/",
}
